import axios from 'axios'

import {
  saveSecurityToken,
  removeSecurityToken,
  getAuthentication,
  updateSecurityToken
} from '../security/securityContext'
import {
  gerarTokenLoginIntegradoUrl,
  loginPorTokenLoginIntegradoUrl
} from '../util/applicationContext'
import { SLOW_REQUEST_CONFIG, SLOW_REQUEST_HEADER } from '../util/operationProgressUtil'
import { BYPASS_AUTH_INTERCEPTOR_HEADER } from '../interceptors/authenticationJwtInterceptors'

export const getUrlLoginSiga = (origin, redirectTo) =>
  `/bff/publico/auth/url-login-siga?urlDestino=${origin}/sso?redirectTo=${redirectTo}`
export const loginUsuarioCorrenteUrl = '/bff/auth/login-usuario-corrente'
const authenticationUrlE2E = '/bff/auth'

export const AUTHENTICATION_FAILED = '@authenticationJwtActions/AUTHENTICATION_FAILED'
export const USER_AUTHENTICATED = '@authenticationJwtActions/USER_AUTHENTICATED'
export const AUTHENTICATION_REFRESHED = '@authenticationJwtActions/AUTHENTICATION_REFRESHED'
export const AUTHENTICATION_SIGA_REDIRECT = '@authenticationJwtActions/AUTHENTICATION_SIGA_REDIRECT'
export const LOGIN_USUARIO_CORRENTE_RECUPERADO =
  '@authenticationJwtActions/LOGIN_USUARIO_CORRENTE_RECUPERADO'
export const USER_LOGOUT = '@authenticationJwtActions/USER_LOGOUT'
export const TOKEN_LOGIN_INTEGRADO_GERADO = '@authenticationJwtActions/TOKEN_LOGIN_INTEGRADO_GERADO'
export const ERRO_AO_GERAR_TOKEN_LOGIN_INTEGRADO =
  '@authenticationJwtActions/ERRO_AO_GERAR_TOKEN_LOGIN_INTEGRADO'

export const axiosWrapper = axios

const AUTH_CONFIG_HEADERS = {
  headers: { [SLOW_REQUEST_HEADER]: true, [BYPASS_AUTH_INTERCEPTOR_HEADER]: true }
}

export const authenticateSiga = (origin, redirectTo) => (dispatch) =>
  axios.get(getUrlLoginSiga(origin, redirectTo), AUTH_CONFIG_HEADERS).then((response) => {
    window.location.assign(response.data)
    return dispatch({
      type: AUTHENTICATION_SIGA_REDIRECT
    })
  })

export const authenticateUserE2E = (data) => (dispatch) =>
  axios
    .post(authenticationUrlE2E, data, SLOW_REQUEST_CONFIG)
    .then((response) => {
      const authentication = {
        tokenJwt: response.data.tokenJwt,
        refreshToken: response.data.refreshToken,
        username: response.data.username,
        isUserAuthenticated: true,
        userFingerPrint: response.data.userFingerPrint
      }
      saveSecurityToken(authentication)

      return dispatch({
        type: USER_AUTHENTICATED,
        payload: authentication
      })
    })
    .catch((err) =>
      dispatch({
        type: AUTHENTICATION_FAILED,
        payload: { err }
      })
    )

export const recuperarLoginUsuarioCorrente = () => (dispatch) => {
  axios.get(loginUsuarioCorrenteUrl).then((response) => {
    const authentication = { ...getAuthentication(), username: response.data }
    saveSecurityToken(authentication)

    return dispatch({
      type: LOGIN_USUARIO_CORRENTE_RECUPERADO,
      payload: authentication
    })
  })
}

export const authenticateTokenLoginIntegrado =
  (username, tokenLoginIntegrado, origin) => (dispatch) =>
    axios
      .post(loginPorTokenLoginIntegradoUrl, { tokenLoginIntegrado }, AUTH_CONFIG_HEADERS)
      .then((response) => {
        const authentication = {
          tokenJwt: response.data.tokenJwt,
          refreshToken: response.data.refreshToken,
          username,
          origin,
          isUserAuthenticated: true,
          userFingerPrint: response.data.userFingerPrint
        }
        saveSecurityToken(authentication)

        return dispatch({
          type: USER_AUTHENTICATED,
          payload: authentication
        })
      })
      .catch((err) =>
        dispatch({
          type: AUTHENTICATION_FAILED,
          payload: { err }
        })
      )

export const gerarTokenLoginIntegrado = (tokenJwt) => (dispatch) =>
  axios
    .post(gerarTokenLoginIntegradoUrl, { tokenJwt }, AUTH_CONFIG_HEADERS)
    .then((response) =>
      dispatch({
        type: TOKEN_LOGIN_INTEGRADO_GERADO,
        payload: response.data
      })
    )
    .catch((err) => ({
      type: ERRO_AO_GERAR_TOKEN_LOGIN_INTEGRADO,
      payload: { err }
    }))

export const logoutUser = () => {
  removeSecurityToken()
  return {
    type: USER_LOGOUT,
    payload: {
      tokenJwt: null,
      isUserAuthenticated: false,
      username: null
    }
  }
}

export const refreshToken = (refreshTokenParam, userFingerPrintParam) => (dispatch) =>
  axios
    .post(
      '/bff/auth/token-jwt/por-refresh-token',
      { refreshToken: refreshTokenParam, userFingerPrint: userFingerPrintParam },
      { timeout: 120000 }
    )
    .then((response) => {
      const authorization = {
        tokenJwt: response.data.tokenJwt,
        refreshToken: response.data.refreshToken,
        userFingerPrint: response.data.userFingerPrint
      }
      updateSecurityToken(authorization)
      return dispatch({
        type: AUTHENTICATION_REFRESHED,
        payload: getAuthentication()
      })
    })
    .catch((err) =>
      dispatch({
        type: AUTHENTICATION_FAILED,
        payload: { err }
      })
    )
